import numeral from 'numeral';
import { unicodeControlCharacters as ucc } from '../constants';
export const convert = pattern => pattern.replace(/(#+[(#,.]*#+)/g, match => `[${match.replace(/#/g, '0')}]`);
const getPattern = (pattern, number) => {
  const patterns = pattern.split(';');
  return patterns[number < 0 && patterns.length > 1 ? 1 : 0];
};
const escapeRegExp = string => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};
export const createPriceFormatter = function (_temp) {
  let {
    currencySymbol = '',
    decimalSymbol = '.',
    groupingSeparator = ',',
    pattern = '0,0.00¤',
    currencyExponent = 0,
    currencyName = ''
  } = _temp === void 0 ? {} : _temp;
  return {
    formatPrice(number) {
      let formattedPrice = numeral(number / 10 ** currencyExponent).format(convert(getPattern(pattern, number).replace('¤', '$'))).replace('$', currencySymbol);
      const decimalPosition = formattedPrice.lastIndexOf('.');
      formattedPrice = formattedPrice.replace(/,/g, groupingSeparator);
      formattedPrice = formattedPrice.slice(0, decimalPosition) + formattedPrice.slice(decimalPosition).replace('.', decimalSymbol);
      formattedPrice = formattedPrice.replace(/ /g, ucc.NBSP);
      return ucc.LRE + formattedPrice + ucc.PDF;
    },
    priceReplaceWithCurrencyName(formattedPriceWithSymbol) {
      if (!currencyName) {
        return formattedPriceWithSymbol;
      }
      const cleanPrice = formattedPriceWithSymbol.replace(ucc.LRE, '').replace(ucc.PDF, '').trim();
      const contentAfterSymbol = cleanPrice.replace(currencySymbol, '').trim();
      let numericSegment = '';
      let trailingSegment = '';
      const numericRegexChars = `0-9${escapeRegExp(decimalSymbol)}${escapeRegExp(groupingSeparator)}${escapeRegExp(ucc.NBSP)}`;
      const numericPattern = new RegExp(`^(-?[${numericRegexChars}]+)`);
      const match = contentAfterSymbol.match(numericPattern);
      if (match) {
        const [, capturedNumericSegment] = match;
        numericSegment = capturedNumericSegment || '';
      }
      if (numericSegment) {
        trailingSegment = contentAfterSymbol.substring(numericSegment.length);
      } else {
        trailingSegment = contentAfterSymbol;
      }
      numericSegment = numericSegment.trim();
      trailingSegment = trailingSegment.trim();
      let numericSegmentForSR = numericSegment;
      if (groupingSeparator) {
        const regexGroupingSep = new RegExp(escapeRegExp(groupingSeparator), 'g');
        numericSegmentForSR = numericSegmentForSR.replace(regexGroupingSep, '');
      }
      const numericFinalForSR = numericSegmentForSR.replace(/ /g, ucc.NBSP);
      let processedTrailingUnitText = '';
      if (trailingSegment) {
        const textToProcess = trailingSegment.replace(/ /g, ucc.NBSP);
        if (textToProcess) {
          processedTrailingUnitText = ucc.NBSP + textToProcess;
        }
      }
      const parts = [];
      if (numericFinalForSR) {
        parts.push(numericFinalForSR);
      }
      parts.push(currencyName);
      let combinedContent = parts.join(ucc.NBSP);
      combinedContent += processedTrailingUnitText;
      return combinedContent;
    }
  };
};
//# sourceMappingURL=formatter.js.map